// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2Enwy","ranges":"BmiRanges_ranges__1kGUd"};